<template>
  <div class="section-terms" id="skilmalar" ref="terms">
    <div class="container">
      <div class="row">
        <div class="col-3">
          <div>
            <h2 class="about-project__h2-title color-primary">Skilmálar</h2>
            <ul class="terms__list">
              <li class="terms__list-item">
                <span class="title">Rekstaraðili</span>
                <p class="text">Mango Studio ehf.<br/> kt. 561219-0280</p>
              </li>

              <li class="terms__list-item">
                <span class="title">Hafa samband</span>
                <p class="text">
                  <span class="email-pseudo">dimitri</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-9">
          <div class="terms__accordion">
            <div class="terms__accordion-item" v-for="(item, i) in accordion" :key="i">
              <div :class="['terms__accordion-item__title', 'title', {'is-opened': selectTabIndex === i}]"
                   @click="changeSelectTabIndex(i)">
                {{ item.title }}
              </div>
              <transition name="accordion">
                <div class="terms__accordion-item__content text" v-show="i === selectTabIndex"
                     v-html="item.content"></div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import terms from "@/store/terms";
import scroll from "@/helpers/scroll";

export default {
  data: () => ({
    accordion: terms.terms,
    selectTabIndex: -1
  }),
  methods: {
    changeSelectTabIndex(i) {
      this.selectTabIndex === i
          ? this.selectTabIndex = -1
          : this.selectTabIndex = i
    },
    scrolling() {
      if (this.$route.hash === '#skilmalar_2') {
        setTimeout(() => {
          let elSkilmalar = this.$refs.terms.getBoundingClientRect().top + window.pageYOffset
          if (this.$device.ios() && this.$store.state.isApp) {
            elSkilmalar = elSkilmalar + 200;
          }
          //window.scrollTo(0, elSkilmalar)
          scroll.to(elSkilmalar);
          this.changeSelectTabIndex(2);
        }, 500);
      }
      if (this.$route.hash === '#skilmalar') {
        setTimeout(() => {
          const elSkilmalar = this.$refs.terms.getBoundingClientRect().top + window.pageYOffset
          window.scrollTo(0, elSkilmalar)
        }, 500)
      }
    }
  },
  /* mounted() {
    setTimeout(() => {
      this.scrolling()
    }, 200)
  }, */
  watch: {
    '$route.hash': {
      immediate: true,
      handler() {
        console.log(this.$route);
        this.scrolling()
      }
    }
  }
}
</script>
